import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Building2, Users, CreditCard, Shield } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsAdmin } from "@/shared/hooks/useIsAdmin";

const allSettingsNav = [
  { name: "Organization", href: "/settings/organization", icon: Building2 },
  { name: "Team", href: "/settings/team", icon: Users },
  { name: "Billing", href: "/settings/billing", icon: CreditCard },
  { name: "Admin", href: "/settings/admin", icon: Shield, adminOnly: true },
];

export default function SettingsLayout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { isAdmin } = useIsAdmin();
  const settingsNav = allSettingsNav.filter((item) => !item.adminOnly || isAdmin);

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-background">
      {/* Horizontal tab nav */}
      <div className="bg-muted/40 shrink-0 px-4 md:px-6">
        <div className="flex items-center">
          <span className="ds-body-sm-strong text-foreground/60 mr-3 py-3.5 hidden sm:block shrink-0">
            Settings
          </span>
          <span className="hidden sm:block w-px h-4 bg-foreground/10 mr-3 shrink-0" />
          <nav className="flex min-w-0 flex-1 overflow-x-auto hidden-scrollbar">
            {settingsNav.map((item) => {
              const isActive = pathname === item.href || pathname.startsWith(item.href + "/");
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    "ds-button-label flex items-center gap-2 px-3 py-3.5 transition-colors whitespace-nowrap rounded-lg",
                    isActive
                      ? "bg-background text-foreground shadow-ambient"
                      : "text-muted-foreground hover:text-foreground hover:bg-background/60",
                  )}
                >
                  <item.icon className="h-4 w-4 shrink-0" />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      <main className="min-h-0 flex-1 overflow-y-auto ds-scrollbar">{children}</main>
    </div>
  );
}
